import React from "react";
import { Button } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const BlogCard = ({ blog }) => {
  const navigate = useNavigate();

  return (
    <div className="blog-cardbox">
      <div className="blog-card">
        <div className="blog-card-image">
          <img
            onClick={() => navigate(`/blog/${blog.slug}`)}
            src={
              blog.banner
                ? blog.banner
                : "https://img.freepik.com/free-photo/brainstorm-meeting_1098-15871.jpg?ga=GA1.1.1656302507.1747552328&semt=ais_hybrid&w=740"
            }
            alt="Blog"
            className="img-fluid"
          />
        </div>
        <div className="blog-card-content p-4">
          <h5
            style={{ cursor: "pointer" }}
            onClick={() => navigate(`/blog/${blog.slug}`)}
          >
            {blog.title}
          </h5>
          <p>{blog.content.replace(/<[^>]*>?/gm, "").slice(0, 80) + "..."}</p>
          <div className="text-right">
            <Button
              variant="text"
              endIcon={<ChevronRightIcon />}
              size="small"
              onClick={() => navigate(`/blog/${blog.slug}`)}
            >
              Read More
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
